import React from "react";
import FoodItem from "./FoodItem";
import { Link } from "react-router-dom";

const AnaYemek = () => {
  const foodItems = [
    { name: "Kebap", ingredients: "Et, Soğan, Lavaş", price: "120₺" },
    { name: "Kebap", ingredients: "Et, Soğan, Lavaş", price: "120₺" },
    { name: "Kebap", ingredients: "Et, Soğan, Lavaş", price: "120₺" },
  ];

  return (
    <div className="pb-12 min-h-screen">
      <div className="relative h-48 overflow-hidden">
        <img src="/images/dingo-header.jpg" alt="Header" className="w-full h-full object-cover opacity-50 absolute inset-0" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center pt-8">
          <Link to="/" className="absolute top-6 left-6 text-amber-500 bg-[#0f172a] p-2 pr-4 rounded-full flex items-center hover:text-amber-400 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <span className="font-semibold uppercase tracking-wider text-sm">Geri</span>
          </Link>
          <h2 className="text-4xl font-bold tracking-tight text-white mb-2 brand-font">Ana Yemekler</h2>
          <div className="h-0.5 w-16 bg-amber-500 rounded-full" />
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 mt-12">
        <div>
          {foodItems.map((item, index) => (
            <FoodItem
              key={index}
              name={item.name}
              ingredients={item.ingredients}
              price={item.price}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnaYemek;
